<mat-icon *ngIf="titleDeactivated && !titleDeactivated?.deactivated"
          color="primary" 
          [svgIcon]="'help'"
          class="help-icon"
          (click)="openDialog($event)"></mat-icon>
